import { alpha, Table, TableCell, TableRow } from '@mui/material';
import { typography } from '@mui/system';

import { CheckIcon, CloseIcon, TeamIcon } from 'assets/svg';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const Scene = styled('section')`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: ${theme.palette.grey[800]};
`;

export const Card = styled('article')`
  z-index: 1;
  position: relative;
  width: min(440px, calc(100% - ${theme.spacing(40)}));
  padding: ${theme.spacing(28, 24)};
  border-radius: 12px;
  border: 1px solid ${alpha(theme.palette.common.white, 0.1)};
  background-color: ${alpha(theme.palette.grey[900], 0.72)};
  box-shadow: 0 24px 48px ${alpha(theme.palette.common.black, 0.45)};
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DetailsWrap = styled('div')`
  align-self: stretch;
  width: 100%;
`;

export const CloseButton = styled('button')`
  border: none;
  background: transparent;
  padding: ${theme.spacing(2)};
  cursor: pointer;
  position: absolute;
  top: ${theme.spacing(12)};
  right: ${theme.spacing(12)};
`;

export const StyledCloseIcon = styled(CloseIcon)`
  width: 18px;
  height: 18px;

  path {
    stroke: ${alpha(theme.palette.common.white, 0.7)};
  }
`;

export const StyledCheckIcon = styled(CheckIcon)`
  width: 52px;
  height: 52px;

  path {
    stroke: ${theme.palette.common.white};
    stroke-width: 1.6;
  }
`;

export const StyledTeamingIcon = styled(TeamIcon)`
  width: 64px;
  height: 64px;

  path {
    stroke: ${alpha(theme.palette.common.white, 0.7)};
  }
`;

export const DetailsTable = styled(Table)`
  width: 100%;
  margin-top: ${theme.spacing(10)};
`;

export const Title = styled(TableCell)`
  width: 33%;
  padding: ${theme.spacing(3)} 0;
  ${typography(theme.typography.textLargeMedium)};
  color: ${theme.palette.grey[50]};
  border-bottom: 1px solid ${theme.palette.grey[600]};
`;

export const Value = styled(TableCell)`
  padding: ${theme.spacing(3)} 0;
  ${typography(theme.typography.body1)};
  color: ${theme.palette.grey[50]};
  border-bottom: 1px solid ${theme.palette.grey[600]};
  white-space: pre-line;
`;

export const StyledTableRow = styled(TableRow)`
  ${typography(theme.typography.body1)};
  color: ${theme.palette.grey[50]};
  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;
